import { AppDataState } from './app-data-store';
import { FilterPreset } from './interface/filter-preset';

export const SET_FILTER_PRESETS = 'SET_FILTER_PRESETS';

export type SetFilterPresetsAction = {
  type: typeof SET_FILTER_PRESETS;
  payload: FilterPreset[];
};

// redux update store action
export const setFilterPresetsAction = (payload: FilterPreset[]): SetFilterPresetsAction => {
  return {
    type: SET_FILTER_PRESETS,
    payload,
  };
};

// redux reducer handler - state updater
export const setFilterPresetsHandler = (
  state: AppDataState,
  action: SetFilterPresetsAction
): AppDataState => {
  return {
    ...state,
    filterPreset: action.payload,
  };
};
